import { query } from '@confluence/query-preloader-tools';

import { MentionsProviderQuery } from './MentionsProviderQuery.graphql';
import type { MentionsProviderQuery as MentionsProviderQueryType } from './__types__/MentionsProviderQuery';

export const preloadMentionsProvider = async () =>
	query<MentionsProviderQueryType, {}>({
		query: MentionsProviderQuery,
	});
